import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
button[name='close-btn'] {
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Cg fill-rule='nonzero' stroke='%23FFF'%3E%3Cpath d='M16.861 1.017L1.097 16.782l.042.041L16.903 1.06l-.042-.042z'/%3E%3Cpath d='M1.097 1.059l15.764 15.764.042-.041L1.139 1.017l-.042.042z'/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    color: transparent;
    width: 12px;
    height: 12px;
    overflow: hidden;
    margin-left: 8px;
    position: absolute;
    background-size: 100%;
    right: 8px;
    top: 8px;
}
.fai-cta {
    display: block;
    position: fixed;
    bottom: calc(8px * 4);
    right: calc(8px * 4);
    background: #086ea1;
    color: #ffffff;
    border-radius: 5px;
    padding: calc(8px * 2);
    padding-right: calc(8px * 3);
    max-width: 310px;
  z-index: 2;
}
a {
    color: #ffffff;
}
.fai-cta strong {
  font-family: 'Nimbus Sans Bold', sans-serif;
  font-style: normal;
}
.fai-cta div {
    padding-top: 8px;
}
`;

export default styles;